import script from "./esWithoutAppointment.vue?vue&type=script&setup=true&lang=ts"
export * from "./esWithoutAppointment.vue?vue&type=script&setup=true&lang=ts"

import "./esWithoutAppointment.vue?vue&type=style&index=0&id=651284a4&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-651284a4"]])

export default __exports__